module.exports = __webpack_public_path__ + "static/media/5.6db60aa6.svg";